import { connect, ConnectedProps } from 'react-redux'

import Group from 'components/accordion/Group'
import { RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { highlight: RootState['accordion']['highlight'] } => ({
  highlight: state.accordion.highlight
})

export const connector = connect(mapStateToProps, null)
export type GroupContainerProps = ConnectedProps<typeof connector>

export default connector(Group)
